import { Button, Stack, Typography } from '@dtx-company/design-system/src'
import { clearImpersonationAccessTokenCookie } from '@dtx-company/ithaca-sdk/src'
import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'
import React from 'react'

interface ImpersonationBannerProps {
  showBanner: boolean
}

const IMPERSONATING_LABEL = 'Impersonating'
const STOP_BUTTON_LABEL = 'Stop Impersonating'

export const ImpersonationBanner = ({ showBanner }: ImpersonationBannerProps): JSX.Element => {
  const { jwt } = useAuthState()
  const [isClearingImpersonation, setIsClearingImpersonation] = React.useState(false)
  return (
    <>
      {showBanner && (
        <Stack
          direction="row"
          alignItems="center"
          gap={3}
          sx={theme => ({
            backgroundColor: theme.palette.warning.light,
            pl: 3,
            fontWeight: theme.typography.fontWeightBold,
            position: 'fixed',
            bottom: 0,
            left: 0,
            zIndex: 2000
          })}
        >
          <Typography variant="labelMedium">
            {IMPERSONATING_LABEL} {jwt?.email ?? 'a user'}
          </Typography>
          <Button
            onClick={async () => {
              setIsClearingImpersonation(true)
              await clearImpersonationAccessTokenCookie()
              location.reload()
            }}
            loading={isClearingImpersonation}
          >
            {STOP_BUTTON_LABEL}
          </Button>
        </Stack>
      )}
    </>
  )
}
